// extracted by mini-css-extract-plugin
module.exports = {"root":"Guide_root__RMANI"};